import { call, options, params } from './helpers';

export const getEvent = ({ id }) => call(`/beta/events/${id}`);

export const getEvents = (payload) => call(`/beta/events${params(payload)}`);
export const getEventsByAsset = ({ assetId, ...payload }) =>
	call(`/beta/events/asset/${assetId}${params(payload)}`);

export const updateEvents = (payload) =>
	call(`/beta/events`, options(payload, 'PUT'));

export const updateEventStatus = (payload) =>
	call(`/beta/events/status`, options(payload, 'PUT'));

export const addEvent = (payload) =>
	call(`/beta/events`, options(payload, 'POST'));

export const addTaskToService = (payload) =>
	call(`/beta/events/service/task`, options(payload, 'POST'));

export const deleteEvent = ({ id }) =>
	call(`/beta/events/${id}`, options(null, 'DELETE'));
